import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import NavigationListing from "./NavigationListing";
import NavigationCreate from "./NavigationCreate";
import { NavigationEdit } from "./NavigationEdit";

export const NavigationAdmin = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={() => {
                    return <NavigationListing path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/create`}
                render={() => {
                    return <NavigationCreate path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/edit/:uuid`}
                render={(props) => {
                    const {
                        match: {
                            params: { uuid },
                        },
                    } = props;
                    return <NavigationEdit path={path} uuid={uuid} />;
                }}
            />
        </Switch>
    );
};

export default NavigationAdmin;
